import React from 'react';
import {backlink,SampleC,SampleD,SampleE,title} from '../constants'
//? import { connect } from 'react-redux'
//import { push } from 'react-router-redux'
//import { fetchQuiz, selectChoice } from '../actions'  
//import safeHtml from 'safe-html';
// Optimization.
import {Col,Row} from 'reactstrap';
class APP extends React.Component {
    render() {
        const {children}=this.props
        //console.log(children)
        return (
            <div className="container">
                <Row>
                    <Col xs={12} sm={6} md={6} className=" text-left">
                    <h2>{title}</h2>
                    </Col>
                    <Col xs={12} sm={6} md={6} className="text-right">
                       <a  href={backlink}>
                           <h4 style={{marginTop:30}}> Back to the Math and CS</h4>
                       </a>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4} sm={4} md={4} className="text-left">
                       <a  href={SampleC}>
                           <h4>SAMPLE C(PDF)</h4>
                       </a>
                    </Col>
                    <Col xs={4} sm={4} md={4} className="text-center">
                       <a  href={SampleD}>
                           <h4>SAMPLE D(PDF)</h4>
                       </a>
                    </Col>
                    <Col xs={4} sm={4} md={4} className="text-right">
                       <a  href={SampleE}>
                           <h4>SAMPLE E(PDF)</h4>
                       </a>
                    </Col>
                </Row>
                <div className="container">
                    {children}
                </div>
            </div>
        );
    }
}
// redux state to component props
/*
const mapStateToProps=(state)=>{
  const {qnum,isFetching,issucessful}=state
  const question=state.quizdata[qnum]
  const {select, correct}=state.quizresult.result[qnum]
  return{
    qnum,
    isFetching,
    issuccessful,
    question,
    select,
    correct
  }
}
*/
// redux dispatch to callback props
/*
const mapDispatchToProps = (dispatch) => {
  return {
    fetchQuiz: (quizID) =>{
      dispatch(fetchQuiz(quizID))
    },
  }
}
*/

//https://github.com/rackt/react-redux/blob/master/docs/api.md#connectmapstatetoprops-mapdispatchtoprops-mergeprops-options
// "connect" returns a new component class connected to a redux store.
export default APP


// WEBPACK FOOTER //
// ./src/containers/APP.js